exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/src/app/packaging/packaging-item/packaging-item.component.css
// module id = ../../../../../src/app/packaging/packaging-item/packaging-item.component.css
// module chunks = 0